<!--  -->
<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>招聘管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
    </p>
    <div class="box">
      <div class="box-nav">
        <search :Tips="Tips" @handelScreen="handelScreen"></search>
        <div class="nav-select">
          <span>职业类型：</span>
          <el-select
            placeholder="请选择职业类型"
            style="width: 200px"
            @change="optionsChange"
            v-model="positionCode"
          >
            <el-option label="全部职位" value=""> </el-option>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="postPosition">发布职位</el-button>
      </div>
      <div class="box-main">
        <div class="flex-box" style="justify-content: space-between">
          <div class="main-nav">
            <div
              :class="isIndex == index ? 'nav-item-active' : 'nav-item'"
              v-for="(item, index) in list"
              :key="index"
              @click="indexChange(item, index)"
            >
              <span style="cursor: pointer">{{ item.name }}</span>
              <div
                style="
                  width: 100%;
                  height: 6px;
                  background-color: #409eff ;
                  margin-top: 10px;
                "
                v-if="isIndex == index"
              ></div>
              <div
                style="
                  width: 100%;
                  height: 6px;
                  background-color: #fff;
                  margin-top: 10px;
                "
                v-else
              ></div>
            </div>
          </div>
          <div style="margin-top: 20px">
            <!-- 回收站：批量恢复 + 批量彻底删除；其它 Tab：批量删除（移入回收站） -->
            <el-button
              type="primary"
              @click="handelClick(true)"
              v-if="!delShow && isIndex == 5"
              >批量恢复</el-button
            >
            <el-button
              type="primary"
              @click="handelClick(false)"
              v-if="!delShow && isIndex == 5"
              style="margin-left: 10px"
              >批量删除</el-button
            >
            <el-button
              type="primary"
              @click="handelClick(false)"
              v-if="!delShow && isIndex != 5"
              >批量删除</el-button
            >
            <div v-if="delShow">
              <el-button type="primary" @click="batchDel"
                >确认{{ hfShow == true ? "恢复" : "删除" }} ({{
                  delList.length
                }})</el-button
              >
              <el-button type="primary" @click="cancelBatch"
                >取消{{ hfShow == true ? "恢复" : "删除" }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="position-box">
          <div
            class="position-item"
            v-for="(item, index) in zwList"
            :key="index"
          >
            <div class="left" style="width: 40px">
              <el-checkbox
                label=""
                @change="checkboxChange(item)"
                :disabled="isIndex != 5 && !canMoveToTrash(item.approveStatus)"
                v-if="delShow"
              ></el-checkbox>
            </div>
            <div class="center">
              <div class="item flex-box2">
                <div
                  style="
                    margin-right: 20px;
                    color: #333;
                    font-size: 16px;
                    font-weight: 500;
                    max-width: 160px;
                  "
                  class="overflow-text"
                  :title="item.positionName"
                >
                  {{ item.positionName }}
                </div>
                <div
                  style="
                    margin-right: 20px;
                    margin-top: 2px;
                    font-size: 14px;
                    max-width: 160px;
                  "
                  class="overflow-text"
                >
                  {{ item.dictPositionCodeName }}
                </div>
                <img
                  src="@/assets/imgs/bianji-blue.svg"
                  alt=""
                  @click="edit(item)"
                  style="cursor: pointer; width: 20px"
                  v-if="isIndex != 5 && item.approveStatus != 2"
                />
              </div>
              <div class="item flex-box">
                <div>{{ item.districtName }}</div>
                <div>{{ item.salaryRange }}</div>
                <div>{{ item.jobTypeName }}</div>
                <div>{{ item.workExperienceName }}</div>
                <div>{{ item.educationName }}</div>
              </div>
              <div class="item flex-box">
                <div style="margin-right: 50px">
                  被查看<span
                    style="color: #000; font-size: 12px; margin-left: 5px"
                    >{{ item.totalView }}</span
                  >
                </div>
                <div style="margin-right: 50px">
                  沟通过<span
                    style="color: #000; font-size: 12px; margin-left: 5px"
                    >{{ item.totalCommunicate }}</span
                  >
                </div>
                <div style="margin-right: 50px">
                  被收藏
                  <span
                    style="color: #000; font-size: 12px; margin-left: 5px"
                    >{{ item.totalCollect }}</span
                  >
                </div>
              </div>
            </div>
            <div class="right">
              <div class="right-item">
                <img
                  src="@/assets/imgs/shenhezhong@3x.svg"
                  alt=""
                  v-if="item.approveStatus == 2"
                />
                <img
                  src="@/assets/imgs/shenheshibai@3x.svg"
                  alt=""
                  v-if="item.approveStatus == 3"
                />
                <p
                  v-if="item.approveStatus == 3"
                  style="
                    color: #fe574a;
                    cursor: pointer;
                    font-size: 12px;
                    margin-top: 5px;
                  "
                  @click="
                    dialogVisible = true;
                    reason = item.reason;
                  "
                >
                  查看原因
                </p>
                <dialogModel
                  :visible.sync="dialogVisible"
                  width="30%"
                  title="原因"
                  :footer="false"
                >
                  <div style="text-align: center; padding: 60px 0">
                    {{ reason }}
                  </div>
                </dialogModel>
              </div>
              <div class="right-item" style="width: 40px">
                <!-- 恢复按钮 -->
                <img
                  src="@/assets/imgs/huifu@3x.svg"
                  alt=""
                  style="margin-bottom: 20px; cursor: pointer"
                  v-if="isIndex == 5"
                  @click="onHf(item)"
                />
                <!-- 开启关闭按钮 -->
                <el-switch
                  :value="item.isShow"
                  @change="onSwitch(item)"
                  style="margin-bottom: 30px"
                  v-if="
                    isIndex != 5 &&
                    isIndex != 3 &&
                    isIndex != 4 &&
                    item.approveStatus != 2 &&
                    item.approveStatus != 3
                  "
                >
                </el-switch>
                <!-- 删除按钮 -->
                <div>
                  <img
                    src="@/assets/imgs/shanchu@3x.svg"
                    alt=""
                    style="cursor: pointer"
                    @click="delPosition(item)"
                    v-if="isIndex == 5 || canMoveToTrash(item.approveStatus)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import search from "../components/search.vue";
// 引入分页组件
import paging from "../../../../components/paging.vue";
import * as API from "@/assets/api/firm/firmRecruit.js";
export default {
  components: {
    search,
    paging,
  },
  data() {
    return {
      //分页数据
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 12, // 一页显示多少个
        totalDevice: 0, //总数
      },
      routeName: "",
      Tips: "搜索职位名称",
      // 搜索名称
      positionName: "",
      // 职位编码二类编码
      positionCode: "",
      // 职位审核状态
      approveStatus: "",
      // 职位回收状态
      delFlag: "",
      // 已发布职业类型
      options: [],
      reason: "",
      list: [
        {
          name: "全部",
          id: 1,
          approveStatus: "",
        },
        {
          name: "开启中",
          id: 2,
          approveStatus: "1",
        },
        {
          name: "关闭中",
          id: 3,
          approveStatus: "0",
        },
        {
          name: "审核中",
          id: 4,
          approveStatus: "2",
        },
        {
          name: "审核失败",
          id: 5,
          approveStatus: "3",
        },
        {
          name: "回收站",
          id: 6,
          delFlag: 2,
        },
      ],
      isIndex: 0,
      // 职位列表
      zwList: [],
      // 删除列表id
      delList: [],
      // 展示选着框
      delShow: false,
      // 恢复按钮显示
      hfShow: false,
      // 控制原因弹框
      dialogVisible: false,
      // 分页
    };
  },
  created() {
    this.getPublishPositionList();
    this.getPublishPositionCodes();
    this.routeName = this.$route.name;
  },
  methods: {
    /**
     * 进入批量选择模式
     * @param {boolean} isRestore true=批量恢复（回收站 tab）；false=批量删除/移入回收站（其它 tab）
     */
    handelClick(isRestore) {
      if (!this.$checkAction()) return;
      this.delShow = true;
      this.hfShow = !!isRestore;
    },
    // 可放入回收站状态：关闭中(0)、审核中(2)、审核失败(3)
    canMoveToTrash(status) {
      return status == 0 || status == 2 || status == 3;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.getPublishPositionList();
    },
    // 获取企业已发布的职位列表
    getPublishPositionList() {
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: {
          companyId: this.$store.getters.getCompany.id,
          publishUserId: this.$store.getters.getUser.id,
          positionName: this.positionName,
          approveStatus: this.approveStatus,
          delFlag: this.delFlag,
          positionCode: this.positionCode,
        },
      };
      API.getPublishPositionList(data).then((res) => {
        this.zwList = res.data.list.map((item) => {
          if (item.approveStatus == 0) {
            item.isShow = false;
          } else if (item.approveStatus == 1) {
            item.isShow = true;
          }
          return item;
        });
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 职业类型筛选
    optionsChange(item) {
      this.positionCode = item;
      this.getPublishPositionList();
    },
    // 获取企业已发布的二类职位编码列表
    getPublishPositionCodes() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
          publishUserId: this.$store.getters.getUser.id,
        },
      };
      API.getPublishPositionCodes(data).then((res) => {
        this.options = res.data;
      });
    },
    // 选择删除
    checkboxChange(item) {
      let isIndex = this.delList.findIndex((items) => {
        return items == item.id;
      });
      if (isIndex != -1) {
        this.delList.splice(isIndex, 1);
      } else {
        this.delList.push(item.id);
      }
    },
    // 放入回收站
    delPosition(item) {
      if (!this.$checkAction()) return
      let that = this;
      if (that.isIndex == 5) {
        this.$confirmWithScroll("是否彻底删除本条招聘信息？删除后不可恢复。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = {
            data: {
              ids: [item.id],
            },
          };
          API.delPosition(data).then((res) => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", "操作成功！");
              this.getPublishPositionList();
            }
          });
        });
      } else {
        this.$confirmWithScroll("是否将本条招聘信息放入回收站？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = {
            data: {
              ids: [item.id],
              delFlag: 2,
            },
          };
          API.trashOrRestore(data).then((res) => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", "操作成功！");
              this.getPublishPositionList();
            }
          });
        });
      }
    },
    cancelBatch() {
      this.delShow = false;
      this.delList = [];
      this.hfShow = false;
    },
    // 批量：回收站内「恢复」→ trashOrRestore；回收站内「删除」→ delPosition；其它 Tab「删除」→ 放入回收站 trashOrRestore
    batchDel() {
      const that = this;
      if (this.delList.length === 0) {
        this.$tool.PromptBox("error", "请至少勾选一个招聘信息！");
        return;
      }
      const ids = [...this.delList];
      if (this.hfShow) {
        this.$confirmWithScroll("是否恢复勾选招聘信息？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          API.trashOrRestore({
            data: { ids, delFlag: 0 },
          }).then((res) => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", "操作成功！");
              that.cancelBatch();
              that.getPublishPositionList();
            }
          });
        });
      } else if (this.isIndex === 5) {
        this.$confirmWithScroll("是否彻底删除勾选的招聘信息？删除后不可恢复。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          API.delPosition({ data: { ids } }).then((res) => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", "操作成功！");
              that.cancelBatch();
              that.getPublishPositionList();
            }
          });
        });
      } else {
        this.$confirmWithScroll("是否将勾选的招聘信息放入回收站？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          API.trashOrRestore({
            data: { ids, delFlag: 2 },
          }).then((res) => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", "操作成功！");
              that.cancelBatch();
              that.getPublishPositionList();
            }
          });
        });
      }
    },
    // 开启/关闭职位
    onSwitch(item) {
      if (!this.$checkAction()) return
      let that = this;
      if (item.isShow == true) {
        this.$confirmWithScroll("确认关闭该职位吗？关闭后职位将不再展示。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = {
            data: {
              id: item.id,
              approveStatus: 0,
            },
          };
          API.closePosition(data).then((res) => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", "操作成功！");
              this.getPublishPositionList();
            }
          });
        });
      } else {
        this.$confirmWithScroll("开启后会进行审核，请稍后查看审核结果！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = {
            data: {
              id: item.id,
              approveStatus: 2,
            },
          };
          API.openPosition(data).then((res) => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", "操作成功！");
              this.getPublishPositionList();
            }
          });
        });
      }
    },
    // 恢复职位
    onHf(item) {
      if (!this.$checkAction()) return
      let that = this;
      this.$confirmWithScroll("是否恢复该职位招聘数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          data: {
            ids: [item.id],
            delFlag: 0,
          },
        };
        API.trashOrRestore(data).then((res) => {
          if (res.code == 0) {
            that.$tool.PromptBox("success", "操作成功！");
            this.getPublishPositionList();
          }
        });
      });
    },
    // 搜索
    handelScreen(value) {
      this.positionName = value;
      this.getPublishPositionList();
    },
    // 切换状态
    indexChange(item, index) {
      this.delList = [];
      this.isIndex = index;
      this.delShow = false;
      this.hfShow = false;
      if (index == 5) {
        this.approveStatus = "";
        this.delFlag = item.delFlag;
      } else {
        this.approveStatus = item.approveStatus;
        this.delFlag = "";
      }
      this.getPublishPositionList();
    },
    // 发布职位
    postPosition() {
      if (!this.$checkAction()) return;
      this.$router.push({
        path: "/Firm/postPosition",
      });
    },
    // 编辑职位
    edit(item) {
      if (!this.$checkAction()) return
      if (item.approveStatus == 2) {
        this.$tool.PromptBox("error", "审核中，不可编辑！");
      } else {
        this.$router.push({
          path: "/Firm/edit",
          query: { positionId: item.id },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  width: 1200px;
  min-height: 700px;
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
  border-radius: 20px;
  padding: 30px;

  .box-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .nav-select {
      font-size: 12px;
      color: #333;
    }
  }

  .box-main {
    width: 100%;
    height: 100%;

    .main-nav {
      width: 70%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;

      .nav-item {
        width: 100px;
        margin: 0 30px;
        font-size: 16px;
        color: #333;
        text-align: center;
        cursor: pointer;
      }

      .nav-item-active {
        cursor: pointer;
        width: 100px;
        margin: 0 30px;
        font-size: 16px;
        color: #409eff ;
        text-align: center;
        cursor: pointer;
      }
    }

    .position-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      font-size: 14px;
      color: #666666;

      .position-item {
        width: 560px;
        height: 100px;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
        border-radius: 15px;
        margin-top: 20px;
        padding: 5px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;

        .center {
          width: 400px;

          .item {
            margin: 10px 0;
            width: 100%;
            justify-content: start;
            font-size: 12px;

            div {
              margin-right: 20px;
            }
          }
        }

        .right {
          width: 120px;
          justify-content: space-between;
          align-items: center;
          display: flex;
          .right-item {
            width: 50px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .position-item:hover {
        box-shadow: 0px 0px 5px 0px #409eff ;
      }
    }
  }
}

// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
